// optimized code for navigation menu control - START
var lastVisited = getCookie('last-visited') || '';

const currentURL2 = window.location.href;
const currentSlug = currentURL2.split('/').filter(Boolean).pop().toLowerCase();
const isEN = currentURL2.includes('/en/');

const normalize = s => (s || '').toLowerCase().trim();
const getSlug = url => url.split('/').filter(Boolean).pop().toLowerCase();

const navLinks = document.querySelectorAll('.site-navigation .site-nav__link, .site-navigation .site-nav__dropdown-link');
const megaMenus = document.querySelectorAll('.site-nav__has-megamenu');
const megaNav = document.querySelector('.site-navigation--meganav');

let currentItem = '';
let isHovering = false;

navLinks.forEach(link => {
  if (getSlug(link.href) === currentSlug) {
    link.closest('.site-nav__expanded-item')?.classList.add('currentLink');
  }
});

const activeLink = document.querySelector('.site-nav--megamenu .currentLink');

let currentParent = '';

if (activeLink) {
  const parentHref = activeLink.closest('.site-nav--megamenu')?.previousElementSibling?.href || '';
  currentParent = parentHref.includes('homme') ? 'homme' : 'femme';
}

if (currentSlug.includes('women')) {
  currentItem = isEN ? 'WOMEN' : 'FEMMES';
} else if (currentSlug.includes('men')) {
  currentItem = isEN ? 'MEN' : 'HOMMES';
} else if (
  (lastVisited.includes('femme') && !activeLink) ||
  (currentParent === 'femme' && activeLink)
) {
  currentItem = isEN ? 'WOMEN' : 'FEMMES';
} else {
  currentItem = isEN ? 'MEN' : 'HOMMES';
}

const isMatch = (text, type) =>
  type === 'women'
    ? text.includes('women') || text.includes('femme')
    : (text.includes('men') && !text.includes('women')) || text.includes('homme');

const applyCurrent = () => {
  if (isHovering) return;

  megaMenus.forEach(menu => {
    const text = normalize(menu.querySelector('.site-nav__link')?.innerText);

    const shouldBeCurrent =
      (currentItem === 'WOMEN' || currentItem === 'FEMMES')
        ? isMatch(text, 'women')
        : isMatch(text, 'men');

    menu.classList.toggle('current', shouldBeCurrent);
  });
};

megaMenus.forEach(menu => {
  menu.addEventListener('mouseover', () => {
    isHovering = true;
    megaMenus.forEach(m => m.classList.remove('current'));
    menu.classList.add('current');
  });

  menu.addEventListener('mouseleave', () => {
    isHovering = false;
    applyCurrent();
  });
});

if (megaNav) {
  megaNav.addEventListener('mouseleave', applyCurrent);
}

const handle = "{{handle}}".toLowerCase();

[
  ['.site-nav--megamenu .site-navigation .site-nav__item', '.site-nav__link'],
  ['.site-nav--is-megamenu .megamenu div', '.site-nav__dropdown-link']
].forEach(([selector, linkSelector]) => {
  document.querySelectorAll(selector).forEach(item => {
    const link = item.querySelector(linkSelector);
    if (!link) return;

    if (getSlug(link.href) === handle) {
      const parentSlug = getSlug(
        item.closest('.site-nav__has-megamenu')?.querySelector('.hcnavlink')?.href || ''
      );
      if (parentSlug === 'femmes') currentItem = 'FEMMES';
      if (parentSlug === 'hommes') currentItem = 'HOMMES';
    }
  });
});

window.addEventListener('load', applyCurrent);
// optimized code for navigation menu control - END